// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { isEmpty } from '../../../../common/utils/immutableHelper';

/**
 * This component prevents sub components from mounting when there's no pointers to track.
 */
export default (DecoratedComponent) => {
    class PointerLayerMountDecorator extends React.Component {
        render() {
            const { pointers, pointersActive } = this.props;

            if (!pointersActive || isEmpty(pointers)) return null;

            return <DecoratedComponent {...this.props} />;
        }
    }

    PointerLayerMountDecorator.propTypes = {
        pointers: PropTypes.array,
        pointersActive: PropTypes.bool,
    };

    return PointerLayerMountDecorator;
};
